import CustomHead from 'components/commons/CustomHead'
import Template from 'components/contact-completed'
import useLocalStorage from 'hooks/useLocalStorage'

const ContactCompleted: React.FC = () => {
  const fromCorrectFormPage = useLocalStorage('refContactPage')

  return (
    <>
      {fromCorrectFormPage ? (
        <>
          <CustomHead
            keyword={'UX/UI 生成AI クラウドネイティブ DevOps モダンアプリケーション開発'}
            image={'https://aitria.co.jp/img/ogp_logo.png'}
            url={'https://aitria.co.jp/contact/thanks'}
            title="お問い合わせいただきありがとうございます。 | Aitria（アイトリア）"
            description="担当者からご連絡させていただきます。お急ぎの場合は、下記日程予約からお打ち合わせ日時をお選びください。"
            noindexNofollow={true}
          />
          <Template />
        </>
      ) : (
        <></>
      )}
    </>
  )
}

export default ContactCompleted
